<ng-select #attribute_component_select [items]="viewItems" [allowClear]="false" [multiple]="false" name="ng-system-list"
    [id]="id" (selected)="selected($event)" [disabled]="disabled" [(ngModel)]="selectedItem"></ng-select>